import i18n from '../locale/i18next';

// E'lon narxini ko'rsatish: USD e'lonlar dollarda (asl summa), so'mdagisi — taxminiy qiymat sifatida.
// Backend `price` ni doim so'mda qaytaradi; USD bo'lsa `currency: 'USD'` va `priceOriginal` ham keladi.
const uzs = (n) => Number(n).toLocaleString('ru-RU');

export const isUsd = (ad) => ad?.currency === 'USD' && ad?.priceOriginal != null;

/** Asosiy narx matni: "$450" yoki "4 500 000 so'm" */
export const priceMain = (ad) => {
  if (isUsd(ad)) return `$${uzs(ad.priceOriginal)}`;
  return ad?.price != null ? i18n.t("{{n}} so'm", { n: uzs(ad.price) }) : null;
};

/** USD e'lon uchun so'mdagi taxminiy narx: "≈ 5 314 000 so'm" */
export const priceApprox = (ad) => (isUsd(ad) && ad.price != null ? i18n.t("≈ {{n}} so'm", { n: uzs(ad.price) }) : null);

/** Xarita belgisi uchun qisqa: "$450" / "4.5 mln" / "800 ming" */
export const priceShort = (ad) => {
  if (isUsd(ad)) return `$${uzs(ad.priceOriginal)}`;
  const p = ad?.price || 0;
  return p >= 1e6 ? i18n.t('{{n}} mln', { n: (p / 1e6).toFixed(p % 1e6 ? 1 : 0) }) : i18n.t('{{n}} ming', { n: Math.round(p / 1000) });
};

/** Matndagi uzun raqamlarni 3 xonadan bo'ladi: "Mos (2900000 so'm)" → "Mos (2 900 000 so'm)" */
export const fmtNums = (s) => String(s).replace(/\d{4,}/g, n => Number(n).toLocaleString('ru-RU'));
